// extracted by mini-css-extract-plugin
export var dropdownItem = "navigation-module--dropdown-item--OrpM-";
export var hasSubMenu = "navigation-module--has-sub-menu--Rlf-w";
export var nav = "navigation-module--nav--QiW0T";
export var navLinkText = "navigation-module--nav-link-text--7xoci";
export var navLinks = "navigation-module--nav-links--U+21p";
export var navbar = "navigation-module--navbar--Y7y-E";
export var subMenu = "navigation-module--sub-menu--u7c-e";